import { PATH_ROOT } from "@/constants";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useUpdatesBreadcrumb = () => {
  const { t } = useTranslation();
  return useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("updates.peerWeek.title.long") },
    ],
    [t],
  );
};

export default useUpdatesBreadcrumb;
